module.exports = __webpack_public_path__ + "img/bg_rit_img.c6f89ba7.png";